import React, { useEffect } from 'react'
import { requiredLabelTxt } from '../../BrnchMasterConstant'
import { Box, Button, Grid } from '@mui/material'
import { Item } from '../../../../../common/snippets'
import DropDownOA from '../../../../../common/dropDownOA'
import Lineinput from '../../../../../common/lineinput'
import { focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../../../common/helper'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import { connect } from 'react-redux'
import { updateModalHeaderDropDownData } from '../../../../../../store/branchAndUserMaster/BUMAction'
const OtherConfigCommonFilter = (props) => {
    const { data,
        nextId = '',
        updateModalHeaderDropDownData,
        getData,
        resetAllValueBrnhMaster, setShowBottom, showBottom
    } = props
    const { common, branchAndUserMasterReducer } = data
const { loginData } = common
const { ModalHeaderDropDownData, BranchDetailsList } = branchAndUserMasterReducer
const branchDetails = Array.isArray(BranchDetailsList) ? BranchDetailsList : []
const isSameId = (firstId, secondId) => String(firstId ?? '') === String(secondId ?? '')
    useEffect(()=>{
        focusElemnt('state')
    },[])
const handleStateValue = (val) => {
        resetAllValueBrnhMaster()
        const cityList = val?.StateID ? removeDuplicatesFromArray(branchDetails.filter((obj) => isSameId(obj?.StateID, val?.StateID)), 'CityID') : []
        const selectedCity = cityList?.[0] || ''
        const brancList = selectedCity?.CityID ? removeDuplicatesFromArray(branchDetails.filter((obj) => isSameId(obj?.StateID, val?.StateID) && isSameId(obj?.CityID, selectedCity?.CityID)), 'BranchID') : []
        updateModalHeaderDropDownData({
            selState: val || '',
            cityOpt: cityList,
            selCity: selectedCity,
            branchOpt: brancList,
            selBranch: brancList?.[0] || '',
            branchCode: brancList?.[0]?.BranchCode || '',
        })
    }
    const handleCityValue = (val) => {
        resetAllValueBrnhMaster()
        const stateId = ModalHeaderDropDownData?.selState?.StateID
        const brancList = val?.CityID ? removeDuplicatesFromArray(branchDetails.filter((obj) => isSameId(obj?.CityID, val?.CityID) && (!stateId || isSameId(obj?.StateID, stateId))), 'BranchID') : []
        updateModalHeaderDropDownData({
            selCity: val || '',
            branchOpt: brancList,
            selBranch: brancList?.[0] || '',
            branchCode: brancList?.[0]?.BranchCode || '',
        })
    }
    const handleBranchValue = (val) => {
        resetAllValueBrnhMaster()
        updateModalHeaderDropDownData({
            selBranch: val || '',
            branchCode: val?.BranchCode || '',
        })
    }
  return (
    <Grid container sx={{ padding: '6px 8px' }}>
            <Grid item md={2.6}>
                <Item >
                    <DropDownOA
                        label={requiredLabelTxt('Company')}
                        id='companyM'
                        defaultvalue={loginData?.strCompanyName}
                        disabled={true}
                        nextId={'state'}
                        prevId={'saveBtn'}
                    />
                </Item>
            </Grid>
            <Grid item md={2.1}>
                <Item >
                    <DropDownOA
                        label={requiredLabelTxt('State')}
                        data={ModalHeaderDropDownData?.stateOpt || []}
                        defaultvalue={ModalHeaderDropDownData?.selState?.StateName || ModalHeaderDropDownData?.selState}
                        value={ModalHeaderDropDownData?.selState?.StateName || ModalHeaderDropDownData?.selState}
                        onSelect={handleStateValue}
                        onReset={() =>handleStateValue('')}
                        id='state'
                        idKey={`StateID`}
                        dataKey={`StateName`}
                        nextId={'city'}
                        prevId={'companyM'}
                        portal={true}
                    />
                </Item>
            </Grid>
            <Grid item md={2.1}>
                <Item >
                    <DropDownOA
                        label={requiredLabelTxt('City')}
                        data={ModalHeaderDropDownData?.cityOpt || []}
                        defaultvalue={ModalHeaderDropDownData?.selCity?.CityName || ModalHeaderDropDownData?.selCity}
                        value={ModalHeaderDropDownData?.selCity?.CityName || ModalHeaderDropDownData?.selCity}
                        onSelect={handleCityValue}
                        onReset={() =>handleCityValue('')}
                        id='city'
                        idKey={`CityID`}
                        dataKey={`CityName`}
                        nextId={'branch_code'}
                        prevId={'state'}
                        portal={true}
                    />
                </Item>
            </Grid>
            <Grid item md={1.2}>
                <Item className={'input--wrapper btmSpaceNotRequired'}>
                    <Lineinput
                        label={requiredLabelTxt('Branch Code')}
                        id={'branch_code'}
                        disabled={true}
                        value={ModalHeaderDropDownData?.branchCode}
                        onKeyDown={(e) => {
                            navigation3(e, "branch_name", 'city', () => { })
                        }}
                    />
                </Item>
            </Grid>
            <Grid item md={3.3}>
                <Item className={'input--wrapper btmSpaceNotRequired'}>
                    <DropDownOA
                        label={requiredLabelTxt('Branch Name')}
                        data={ModalHeaderDropDownData?.branchOpt || []}
                        defaultvalue={ModalHeaderDropDownData?.selBranch?.BranchName || ModalHeaderDropDownData?.selBranch}
                        value={ModalHeaderDropDownData?.selBranch?.BranchName || ModalHeaderDropDownData?.selBranch}
                        onSelect={handleBranchValue}
                        onReset={() =>handleBranchValue('')}
                        id={'branch_name'}
                        idKey={`BranchID`}
                        dataKey={`BranchName`}
                        nextId={'goBtn'}
                        prevId={'branch_code'}
                        portal={true}
                    />
                </Item>
            </Grid>
            
            <Grid item md={0.5} >
                <Box sx={{ paddingTop: '7px' }} className='reportButton'>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button id='goBtn' variant="contained" style={{ ...sx.fullHeight, ...sx.novp, width: '100%' }} className="btn btn-primary"
                            onKeyDown={(e) => {

                                navigation3(e, nextId, 'branch_name', () => { })
                            }}
                            onClick={() => {
                                getData()
                            }}
                        >
                            GO
                        </Button>
                    </Item>
                </Box>

            </Grid>
        </Grid>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModalHeaderDropDownData }
export default connect(mapStateToProps, mapDispatchToProps)(OtherConfigCommonFilter)
// export default OtherConfigCommonFilter
